import React from "react";
import { defineMessage } from "react-intl";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import { SelectFilter } from "../../../components/filter/SelectFilter.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/Select.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { useBoUserGroups } from "../hooks.js";
const label = defineMessage({
  id: "AalFilter_label",
  defaultMessage: "AAL"
});
function AalFilter({ filterBy, hasLabel = true, ...props }) {
  const { items } = useBoUserGroups({
    viewType: "AalFilter",
    fields: ["id", "name"]
  });
  const aalRoles = items.filter((item) => item.name.startsWith("aal_") && !item.name.startsWith("aal_managers_"));
  const aalRolesNames = aalRoles.map((role) => role.name).sort();
  const options = aalRolesNames.map((name) => ({
    value: aalRoles.find((role) => role.name === name)[filterBy === "group_id" ? "id" : "name"],
    label: name
  }));
  return /* @__PURE__ */ React.createElement(SelectFilter, { ...props, options, label: hasLabel ? label : void 0, hasSearch: true });
}
export {
  AalFilter
};
//# sourceMappingURL=AalFilter.js.map
